/**
 * Component Entry
 *
 */

import Autocomplete from './Autocomplete'
export default Autocomplete
export * from './Autocomplete'
